import { ProductPageBreadcrumb } from '@graphcommerce/magento-product'
import { Box, Theme, useMediaQuery } from '@mui/material'
import { ProductPage2Query } from '../../../graphql/ProductPage2.gql'
import { ProductPageMobileBreadcrumb } from '../ProductPageMobileBreadcrumb/ProductPageMobileBreadcrumb'

type ProductPageBreadCrumbsProps = {
  product: NonNullable<NonNullable<ProductPage2Query['products']>['items']>[0]
}

export function ProductPageBreadCrumbs(props: ProductPageBreadCrumbsProps) {
  const { product } = props
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  return (
    <Box sx={{ py: 1 }}>
      {isMobile ? (
        <ProductPageMobileBreadcrumb {...product} />
      ) : (
        <ProductPageBreadcrumb
          name={product?.name}
          categories={product?.categories}
          separator='-'
        />
      )}
    </Box>
  )
}
